module.exports = __webpack_public_path__ + "static/media/Hercules.c6023512.jpg";